import { render, staticRenderFns } from "./iconCadeau.vue?vue&type=template&id=41f41da1"
import script from "./iconCadeau.vue?vue&type=script&lang=js"
export * from "./iconCadeau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports